import { Step as ModelStep } from "@redotech/redo-model/return-flow";
import { manualReviewFromModel } from "@redotech/redo-model/return-flow-step-from-model";
import {
  isManualReviewStepValid,
  ManualReviewState,
} from "@redotech/redo-model/return-flow-step-valid";
import { BlockLayout } from "@redotech/redo-web/flowchart";
import EyeIcon from "@redotech/redo-web/icon-old/eye.svg";
import { produce } from "immer";
import * as React from "react";
import { StepDownstream, StepType, StepTypeDetailsProps } from "../step";

export const MANUAL_REVIEW = (
  Details: React.ComponentType<StepTypeDetailsProps<ManualReviewState>>,
): StepType<ManualReviewState, ModelStep.ManualReview> => ({
  Details: (props: StepTypeDetailsProps<ManualReviewState>) =>
    React.createElement(Details, props),
  customTitle(state) {
    return state.customTitle;
  },
  title: "Mark for manual review",
  valid(state, flowType) {
    return isManualReviewStepValid(state, flowType).valid;
  },
  Icon: EyeIcon,
  iconColor: "success",
  description() {
    return "Mark for manual review";
  },
  downstream(state) {
    const result: StepDownstream[] = [];
    if (state.next !== undefined) {
      result.push({ id: state.next });
    }
    return result;
  },
  maxDownstream() {
    return 1;
  },
  empty: { next: undefined, reason: "" },
  stepDeleted(state, stepId) {
    return produce(state, (state) => {
      if (state.next === stepId) {
        state.next = undefined;
      }
    });
  },
  updateConnection(state, handleIndex, targetStepId) {
    if (handleIndex !== 0) {
      throw new Error(
        `Invalid handle index ${handleIndex} for Manual Review step`,
      );
    }
    return produce(state, (draft) => {
      draft.next = targetStepId;
    });
  },
  removeConnection(state, targetStepId) {
    return produce(state, (draft) => {
      if (draft.next === targetStepId) {
        draft.next = undefined;
      }
    });
  },
  layout() {
    return BlockLayout.FULL;
  },
  toModel(state, id) {
    return {
      customTitle: state.customTitle,
      type: ModelStep.MANUAL_REVIEW,
      next: state.next ? id(state.next) : undefined,
      reason: state.reason,
    };
  },
  fromModel(model, id) {
    return manualReviewFromModel(model, id);
  },
});

export { type ManualReviewState } from "@redotech/redo-model/return-flow-step-valid";
